import {DTCreativeNode, DTNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaigns/utils/trimDescription';

export function serializeConceptCreativeNode(node: DTNode, newNode: ServerNode) {
  const creativeNode = node as DTCreativeNode;

  return {
    ...newNode,
    description: trimDescription(newNode),
    type: NodeType.CONCEPT_CREATIVE,
    creativeId: creativeNode.creativeId,
    landingPage: creativeNode.landingPage,
    landingPageSource: creativeNode.landingPageSource,
    utmParams: creativeNode.utmParams,
    images: creativeNode.images,
    requireLocation: creativeNode.requireLocation,
    requireProduct: creativeNode.requireProduct,
  };
}

export function serializeCreativeNode(node: DTNode, newNode: ServerNode) {
  const creativeNode = node as DTCreativeNode;

  return {
    ...newNode,
    description: trimDescription(newNode),
    type: NodeType.CREATIVE,
    creativeId: creativeNode.creativeId,
    landingPage: creativeNode.landingPage,
    landingPageSource: creativeNode.landingPageSource,
    utmParams: creativeNode.utmParams,
    images: creativeNode.images,
    requireLocation: creativeNode.requireLocation,
    requireProduct: creativeNode.requireProduct,
  };
}

